<template>
  <div v-loading="loading">
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          待付款合同
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        合同基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.finalCustomer }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ Number(info.orderSales).toFixed(2) }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际结算金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.actualSettlementAmount }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预付款比例：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.prepaymentRatioStr }}</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                冲销金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.borrowPrice }}元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-2">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首付款金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{
                  (info.prepaymentAmountStr + info.borrowPrice).toFixed(2)
                }}
                  元</span>
                <span class="amountSty">公式：（实际结算金额-冲销金额）*预付款比例+冲销金额</span>
              </div>
            </div>
          </div>

          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.assignAll }} 元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ unallocatedAmount() }}元</span>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配比例：
              </div>
              <div class="rj-baseinfo__item">
                <span class="money">{{ info.proportion }} %</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="deliveryNumList.length !== 0">
        此合同下有未分配完成的分批发货申请单，请点击分批申请单号进行分配：
      </div>
      <div v-for="(item, index) in deliveryNumList" :key="index">
        <div style="padding: 10px 0; width: 20%; float: left; height: 30px">
          <span
            class="money"
            style="margin-right: 20px; cursor: pointer"
            @click="toPath(item)"
          >{{ item.deliveryNum }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="deliveryNumList.length === 0"
      class="rj-page-card"
      style="clear: both"
    >
      <div class="rj-page-card__title">
        款项分配
      </div>
      <div class="rj-page-card__content">
        <p v-if="CustomizationList.length" style="padding: 10px 0; color: red">
          此单涉及定制化产品，具体型号为：
          <el-tag v-for="(item, index) in CustomizationList" :key="index">
            {{ item.productName }}
          </el-tag>
          下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
        </p>
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column
            prop="telegraphicTransferNum"
            label="电汇底单编号"
            width="190"
            align="left"
            fixed="left"
          />
          <el-table-column
            prop="remittanceAmount"
            label="汇款金额"
            min-width="100"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="remittanceDate"
            label="汇款日期"
            align="left"
          />
          <el-table-column
            prop="importAccount"
            label="汇入账户"
            align="left"
          />
          <el-table-column
            prop="importCompany"
            label="汇入公司"
            align="left"
          />
          <el-table-column
            prop="arrivalMoneyDate"
            label="到款日期"
            align="left"
          />
          <el-table-column
            prop="summary"
            label="摘要"
            align="left"
            width="180"
          />
          <el-table-column
            prop="usedAmount"
            label="已使用金额"
            min-width="100"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="unusedAmount"
            label="可用余额"
            min-width="100"
            align="right"
            header-align="left"
          />
          <el-table-column
            prop="assignAmount"
            label="本次分配金额"
            width="150"
            align="right"
            header-align="left"
          >
            <template v-slot="{ row }">
              <el-input-number
                v-model="row.assignAmount"
                style="width: 100%"
                :precision="2"
                :min="0"
                label="描述文字"
                @blur="assignBlur(row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="submit">
            确认分配
          </el-button>
          <div
            style="
              color: #606266;
              height: 41px;
              line-height: 41px;
              display: inline-block;
              margin-left: 20px;
            "
          >
            <div>
              本次分配总和：<span class="money">{{ assignAllTotal }} 元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="确认分配"
      :visible.sync="dialogVisible"
      width="620px"
      top="15px"
    >
      <span v-if="sureNum > 0" style="color: red">注：已分配金额总计{{
        (info.assignAll + allAmount() * 1).toFixed(2)
      }}和首付款{{
        (info.prepaymentAmountStr + info.borrowPrice).toFixed(2)
      }}差{{ sureNum.toFixed(2) }}元，请分配足额首付款，否则会影响下单。</span>
      <el-table
        :data="tableDialog"
        border
        style="width: 100%"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="index" width="60" label="序号" align="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" />
        <el-table-column
          prop="telegraphicTransferNum"
          label="电汇底单编号"
          align="left"
        />
        <el-table-column
          prop="actualSettlementAmount"
          label="实际结算金额"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="assignAmount"
          label="本次分配金额"
          align="right"
          header-align="left"
        />
      </el-table>
      <div class="footer-btn">
        <el-button type="default" @click="cancel">
          取消
        </el-button>
        <el-button type="primary" :loading="loading" @click="submitAxios">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import axios, { getContractDetailAllInfoByConNum, dealtContractToAssignInfoListTransfer, selectAssignInfoByUserCodeAndContractNum, getNotAssignedPartialByContractNum } from '@/API';
import { MathAdd, Subtr, getNum } from '@/libs/util';
import Big from 'big.js';
export default {
  data () {
    return {
      loading: false,
      tableData: [],
      info: {},
      dialogVisible: false,
      deliveryNumList: [],
      tableDialog: [],
      isSureText: true,
      sureNum: 0
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
  },
  computed: {
    // 定制化产品
    CustomizationList () {
      if (!this.info.contractProductInfos) {
        return [];
      }
      return this.info.contractProductInfos.filter((item) => {
        return item.customizationOrNot;
      });
    },
    unassignAll () {
      if (this.info.contractSum) {
        return MathAdd(this.info.contractSum, this.info.assignAll ? this.info.assignAll * -1 : 0);
      }
      return 0;
    },
    assignAllTotal () {
      let total = this.tableData.reduce((pre, cur) => getNum(Big(getNum(cur.assignAmount)).plus(pre).toString()), 0);
      return total;
    }
  },
  methods: {
    toPath (trg) {
      let parmas = {
        id: trg.partialId,
        masterContractNum: this.contractNum,
        deliveryNum: trg.deliveryNum
      };
      // 跳转到 BatchBase
      this.$router.push({ name: 'BatchBase', query: parmas });
    },
    // 提交分配的按钮
    submit () {
      if (this.assignAllTotal > this.info.actualSettlementAmount) {
        this.$notify({
          title: '本次分配金额大于未分配金额，请进行调整',
          type: 'warning'
        });
        return;
      }
      let payList = [];
      let newList = [];
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          payList.push({
            // contractId: this.info.id,
            telegraphicTransferNum: item.telegraphicTransferNum,
            assignAmount: item.assignAmount,
            businessEntity: item.bussinessEntity
          });
          newList.push(item);
        }
      });
      newList.forEach((item) => {
        item.actualSettlementAmount = this.info.actualSettlementAmount;
        item.contractNum = this.info.contractNum;
      });
      if (!payList.length) {
        this.$notify({
          title: '请输入相应的分配款项',
          type: 'warning'
        });
        return;
      }
      // dialog 弹框 触发
      this.dialogVisible = true;
      this.tableDialog = newList;
      // 计算 是否显示预付款 提示信息
      this.sureNum = (this.info.prepaymentAmountStr + this.info.borrowPrice) - this.info.assignAll - this.allAmount();
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.allAmount();
        }
      });
      return sums;
    },
    // 实际结算金额总计
    allAmount () {
      let cont = 0;
      this.tableDialog.forEach((item) => {
        cont = MathAdd(cont, item.assignAmount);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    cancel () {
      this.dialogVisible = false;
    },
    submitAxios () {
      let payList = [];
      this.tableData.forEach((item) => {
        if (item.assignAmount) {
          payList.push({
            // contractId: this.info.id,
            telegraphicTransferNum: item.telegraphicTransferNum,
            assignAmount: item.assignAmount,
            businessEntity: item.bussinessEntity
          });
        }
      });

      let params = {
        id: this.info.id,
        contractNum: this.info.contractNum,
        contractType: this.info.contractType,
        assignInfoListVOList: payList
      };
      this.loading = true;
      dealtContractToAssignInfoListTransfer(params).then((res) => {
        this.dialogVisible = false;
        let json = res.data;
        if (json.status === '200') {
          this.$notify({
            title: '分配成功',
            type: 'success'
          });
          this.initData();
        }
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }).catch(() => {
        this.loading = false;
      });
    },
    initData () {
      this.loading = true;
      axios.all([selectAssignInfoByUserCodeAndContractNum(this.contractNum), getContractDetailAllInfoByConNum(this.contractNum)]).then((res) => {
        this.loading = false;
        let first = res[0].data;
        if (first.status === '200') {
          first.data.forEach((item) => {
            item.assignAmount = 0;
          });
          this.tableData = first.data;
        }
        let Second = res[1].data;
        if (Second.status === '200') {
          this.info = Second.data;
        }
      }).catch(() => {
        this.loading = false;
      });
      let numberParmas = this.contractNum;
      getNotAssignedPartialByContractNum({ contractNum: numberParmas }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.deliveryNumList = json.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        row.assignAmount = row.unusedAmount;
      }

      const num = this.tableData.reduce((pre, cur) => {
        if (cur.assignAmount > 0) {
          pre = Big(pre).plus(getNum(cur.assignAmount)).toNumber();
        }

        return pre;
      }, 0);

      if (num > this.unallocatedAmount()) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    },
    unallocatedAmount () {
      let num = 0;
      num = Subtr(this.info.actualSettlementAmount, this.info.assignAll);
      return num;
    }
  },
  mounted () {
    this.initData();
  },
  filters: {
    numFilter (value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      return realVal;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../style/var";
.money {
  color: $--color-primary;
}
.amountSty {
  color: gray;
  font-size: 10px;
  display: inline-block;
  margin-left: 10px;
}

.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
